import { styled } from '@mui/material/styles';
const RepunchIcon = (props) => (
	<svg
		fill="#919EAB"
		height="40px"
		width="40px"
		version="1.1"
		id="Layer_1"
	 xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512"
		stroke="#ffffff"
	>
		<g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
		<g
			id="SVGRepo_tracerCarrier"
			strokeLinecap="round"
			strokeLinejoin="round"
		></g>
		<g id="SVGRepo_iconCarrier">
			{' '}
			<g>
				{' '}
				<g>
					{' '}
					<path d="M342.905,355.487h55.776c5.632,0,10.199-4.567,10.199-10.199v-50.763h92.92c5.632,0,10.199-4.567,10.199-10.199V145.534 c0-4.933-3.531-9.159-8.386-10.037l-32.473-5.869V55.921c0-5.632-4.567-10.199-10.199-10.199H280.645 c-5.632,0-10.199,4.567-10.199,10.199v37.434l-43.04-7.779c-56.459-10.202-114.093,5.039-158.124,41.826 C25.252,164.188,0,218.191,0,275.567v180.512c0,5.632,4.566,10.199,10.199,10.199h234.127h257.475 c5.632,0,10.199-4.567,10.199-10.199v-55.127c0-5.632-4.567-10.199-10.199-10.199H254.525v-96.229h78.181v50.763 C332.706,350.92,337.273,355.487,342.905,355.487z M388.483,335.089h-35.378v-40.564h35.378V335.089z M290.845,66.12h159.898 v59.821L290.845,97.042V66.12z M491.602,411.151v34.728H254.525v-34.728H491.602z M244.326,274.126 c-5.633,0-10.199,4.567-10.199,10.199V445.88H20.398v-58.075h79.949c5.633,0,10.199-4.567,10.199-10.199 s-4.566-10.199-10.199-10.199H20.398v-91.839c0-51.313,22.585-99.612,61.962-132.51c39.378-32.9,90.921-46.535,141.418-37.407 l267.823,48.405v120.07H244.326z"></path>{' '}
				</g>{' '}
			</g>{' '}
			<g>
				{' '}
				<g>
					{' '}
					<path d="M150.935,367.405h-7.783c-5.633,0-10.199,4.567-10.199,10.199c0,5.632,4.566,10.199,10.199,10.199h7.783 c5.633,0,10.199-4.567,10.199-10.199C161.134,371.972,156.568,367.405,150.935,367.405z"></path>{' '}
				</g>{' '}
			</g>{' '}
		</g>
	</svg>
);


const CssRepunchSvg = styled(RepunchIcon)(({ theme }) => ({
	fill: theme.palette.text.secondary,
	height: 'auto',
	maxHeight: 'calc(1vh + 1.7vw)',
	width: ' 100%',
}));
export default CssRepunchSvg;
